import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import ProjectCard from "../components/Projects/ProjectCard";
import Particle from "../components/Particle";
import pg from "../assets/projects/pg.png";
import project from "../assets/projects/project.jpeg";
import vue from "../assets/projects/vue.png";
import project1 from "../assets/projects/project1.png";
import flutter from "../assets/projects/flutter.png";
import paymenttracker from "../assets/projects/paymenttracker.png";

const Projects = () => {
  return (
    <Container fluid className="project-section">
      <Particle />
      <Container>
        <h1 className="project-heading">
          Recent Top <strong className="yellow">Works </strong>
        </h1>
        <p style={{ color: "white" }}>
          Here are a few projects I've worked on recently.
        </p>
        <Row style={{ justifyContent: "center", paddingBottom: "10px" }}>
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={paymenttracker}
              title="Payment Tracker System"
              description="This system digitizes paper-based class payment tracking using Next.js, Tailwind CSS, and Supabase. It allows admins to manage classes, students, and payment records efficiently, while parents and students can access their details and payment status securely using their identity number. The platform provides a modern, transparent, and user-friendly solution for managing student and payment information in institutions."
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={project1}
              title="ERP System (Freelance)"
              description="Built with React, Redux, Ant Design, and Node.js, this efficient ERP system streamlines core business operations. It empowers companies to effortlessly manage Sales, Purchase Orders, Stock, Billing, Item Configuration, Promotions, and Supplier relationships. By simplifying complex workflows through a modern and responsive UI, this solution boosts productivity and delivers a seamless user experience."
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={project}
              title="Report System (Freelance)"
              description="Developed using Laravel, React, and Material-UI (MUI), this system seamlessly integrates with Shopify to fetch the latest data in real time. It empowers users with the ability to generate customized reports and visualizations tailored to their business needs. These insights can be easily exported for analysis, presentation, and other operational purposes—making data-driven decisions more accessible than ever."
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={vue}
              title="Daysmart Vet"
              description="Led the successful migration from CodeIgniter to Vue.js, modernizing the platform architecture for scalability. Redesigned the UI/UX for over 6,000 clinics, improving customer satisfaction and achieving negative churn. Delivered new features that enhanced daily clinic workflows and introduced a reusable design system that cut development time for new features by 30%. Also proposed workflow optimizations that significantly boosted engineering productivity."
            />
          </Col>
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={vue}
              title="Fleet Marketplace (Safe Truck)"
              description="Developed a pioneering marketplace tailored for the vibrant fleet community, providing a seamless platform for buying, selling, and managing a wide range of fleet-related products and services. Built with Vue.js, Laravel, Element Plus, and Stripe, the platform ensures a smooth user experience with secure transactions, intuitive UI components, and scalable backend infrastructure."
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={flutter}
              title="Driver Management Application (Safe Truck)"
              description="Created an innovative Flutter and Laravel-based application that enables companies to monitor real-time driver locations, track task completion, and gain valuable insights into vehicle condition and performance, optimizing operations, enhancing accountability, and ensuring fleet safety."
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={flutter}
              title="Wireman Management Application (Safe Truck)"
              description="Created a cutting-edge Flutter and Laravel application that empowers wiremen to efficiently update task progress and manage hardware resource allocation, ensuring optimal productivity and resource utilization."
            />
          </Col>

        </Row>
      </Container>
    </Container>
  )
}

export default Projects